import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ItemDeleteModalProps {
  onDelete: () => void;
  opened: boolean;
  onClose: (value: boolean) => void;
}
export const ItemDeleteModal: FC<ItemDeleteModalProps> = t0 => {
  const $ = _c(12);
  const {
    onDelete,
    onClose,
    opened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.store.item.delete_confirmation");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.store.item.delete_success");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = () => onClose(false);
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onDelete || $[7] !== opened || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <ConfirmationModal confirmationText={t1} toastCaption={t2} opened={opened} onClose={t3} onConfirm={onDelete} />;
    $[6] = onDelete;
    $[7] = opened;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};